import { ToastProvider } from '@zillow/constellation-10';
import { Auth, MfaStepUpBoundary } from '@common/auth/AuthProvider';
import BlockedUserModalGate from '@rental-manager/components/BlockedUserModalGate';
import { ManagerAuthProvider } from '@rental-manager/auth/ManagerAuthProvider';
import AppContainer from './container';

export default function RentalManagerApp({ enabled }: { enabled: boolean }) {
  const app = (
    <ToastProvider>
      <BlockedUserModalGate />
      <AppContainer />
    </ToastProvider>
  );

  if (!enabled) {
    return __BROWSER__ ? (
      <Auth.Provider>
        <MfaStepUpBoundary>{app}</MfaStepUpBoundary>
      </Auth.Provider>
    ) : (
      app
    );
  }

  return <ManagerAuthProvider>{app}</ManagerAuthProvider>;
}
